<template>
  <div id="app" :class="pageClasses">
    <template v-if="isAuth">
      <div v-if="loading" class="loading-container">
        Loading...
      </div>
      <template v-else>
        <app-header></app-header>
        <main>
          <section class="page-container-scrollable section">
            <default v-if="theme === 'default'"></default>
            <stryker v-else-if="theme === 'stryker'"></stryker>
            <ford v-else-if="theme === 'ford'"></ford>
          </section>

          <!-- <transition v-else name="fade" mode="out-in">
          <router-view></router-view>
        </transition> -->
        </main>
      </template>
    </template>
    <template v-else>
      <router-link to="/" class="logotype">
        <img src="./assets/images/ueg_logo.svg" />
      </router-link>
      <router-view></router-view>
    </template>
    <div class="version">{{ version }}</div>
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader';
import axios from 'axios';
import _ from 'lodash';

import OrganizationsList from '@/views/Organizations/OrganizationsList.vue';
import ProjectsLists from '@/views/Projects/ProjectsList.vue';
import ProjectShow from '@/views/Projects/ProjectsShow.vue';
import FileShow from '@/views/Files/FileShow.vue';
import VideoShow from '@/views/Projects/VideoShow.vue';
import NotFound from '@/views/NotFound.vue';

export default {
  name: 'App',
  permissions: [],
  components: {
    AppHeader,
    default: () => import('@/main/Default.vue'),
    stryker: () => import('@/main/Stryker.vue'),
    ford: () => import('@/main/Ford.vue')
  },
  data() {
    return {
      loading: true
    };
  },
  computed: {
    version() {
      return 'v' + process.env.VUE_APP_VERSION;
    },
    pageClasses() {
      const classes = {
        'is-auth': this.isAuth,
        'is-guest': !this.isAuth
      };
      if (this.$route.name) {
        classes['page-' + this.$route.name.replace('.', '-')] = true;
      }
      return classes;
    },
    theme() {
      console.log('theme', this.$store.state.user.roles[0].organizationID);
      if (this.$store.state.user.roles[0].organizationID == 15)
        return 'default';
      //stryker
      else if (this.$store.state.user.roles[0].organizationID == 23) {
        //18 in stage and dev...
        return 'ford';
      } else return 'default';
    }
  },
  mounted() {
    console.log('mounted');

    if (this.isAuth) {
      this.$store.commit('setAuthToken', localStorage.getItem('authToken'));
      this.axiosRequest('get', `Users/${localStorage.getItem('userID')}`)
        .then(response => {
          this.$store.commit('setUser', response.data);
          this.initApp();
        })
        .catch(error => {
          this.logout();
          console.error(error);
        });
    }
  },
  methods: {
    initApp() {
      /*const organizationID = this.hasRole('ueg')
      ? this.organizationID || this.$store.getters.userOrganization
      : this.$store.getters.userOrganization;*/
      /*console.log(organizationID);
    this.axiosRequest('get', 'Projects', {
      IncludeTrashed: false,
      OrganizationId: organizationID
    })
      .then(response => {
        this.$store.commit('projects/set', response.data);
      })
      .catch(error => {
        this.showErrorMessage(error);
      });
*/
      console.log('initApp');

      // from Groups/{id} get the organization ID
      const args = {
        IncludeTrashed: false
      };

      if (!this.hasRole('ueg'))
        args.OrganizationID = this.$store.getters.userOrganization;

      axios
        .all([
          this.axiosRequest('get', `Organizations`, {}),
          this.axiosRequest('get', `Users/Permissions`, {}),
          this.axiosRequest('Users/Roles'),
          this.axiosRequest(
            `Users/${localStorage.getItem('userID')}/Permissions`
          ),
          this.axiosRequest('get', 'Users', args),
          this.axiosRequest('get', 'Projects', {
            IncludeTrashed: false,
            OrganizationId: this.$store.getters.userOrganization
          })
        ])
        .then(
          axios.spread(
            (
              divisions,
              permissions,
              user_roles,
              user_permissions,
              users,
              projects
            ) => {
              console.log(divisions.data);
              this.$store.commit('organizations/set', divisions.data);
              this.$store.commit('permissions/set', permissions.data);
              this.$store.commit('initApp', {
                divisions: _.flatMap(divisions.data, 'groups'),
                roles: user_roles.data,
                permissions: user_permissions.data
              });
              this.$store.commit(
                'groups/set',
                _.flatMap(divisions.data, 'groups')
              );
              this.$store.commit('users/set', users.data);
              this.$store.commit('projects/set', projects.data);
              // console.log(JSON.stringify(this.$route));
              this.setupRoutes();
            }
          )
        )
        .catch(console.error);
    },
    setupRoutes() {
      console.log('setting up routes');

      const projectRoutes = (basePath = '', breadcrumbsPrepend = []) => [
        {
          path: basePath + ':projectID',
          name: 'projects.details',
          component: ProjectShow,
          meta: {
            title: 'Project Detail',
            breadcrumbs: [...breadcrumbsPrepend, 'projects.list']
          }
        },
        {
          path: basePath + ':projectID/files/:fileID',
          name: 'projects.files.view',
          component: FileShow,
          meta: {
            title: 'View file',
            breadcrumbs: [
              ...breadcrumbsPrepend,
              'projects.list',
              'projects.details'
            ]
          }
        },
        {
          path: basePath + ':projectID/videos/:videoId',
          name: 'projects.video',
          component: VideoShow,
          meta: {
            title: 'Research Videos',
            breadcrumbs: [
              ...breadcrumbsPrepend,
              'projects.list',
              'projects.details'
            ]
          }
        }
      ];
      let routes = [];
      if (this.hasRole('ueg')) {
        routes = [
          {
            path: '/organizations',
            name: 'organizations',
            component: OrganizationsList,
            meta: {
              title: 'All Organizations',
              breadcrumbs: []
            }
          },
          ...projectRoutes('/organizations/:organizationID/projects/', [
            'organizations'
          ]),
          {
            path: '/',
            redirect: { name: 'organizations' },
            name: 'home'
          },
          {
            path: '/organizations/:organizationID/projects',
            component: ProjectsLists,
            name: 'projects.list',
            props: true,
            meta: {
              title: 'All Projects',
              breadcrumbs: ['organizations']
            }
          }
        ];
      } else {
        routes = [
          ...projectRoutes('/projects/'),
          {
            path: '/',
            redirect: { name: 'projects.list' },
            name: 'home'
          },
          {
            path: '/projects',
            component: ProjectsLists,
            name: 'projects.list',
            props: true,
            meta: {
              title: 'All Projects',
              breadcrumbs: []
            }
          }
        ];
      }
      routes.push({
        path: '*',
        component: NotFound
      });
      this.$router.addRoutes(routes);
      this.loading = false;
    }
  }
};
</script>

<style lang="scss">
@import '@/sass/default/style.scss';

.is-guest {
  .logotype {
    position: fixed;
    width: 250px;
    top: 40px;
    left: 50px;
  }
}

.version {
  font-size: 1rem;
  position: fixed;
  bottom: 1rem;
  left: 1rem;
  opacity: 0.4;
}
</style>
